/** @format */

// src/components/ui/Modal.tsx
import { FC, ReactNode, useEffect } from "react";
import "./Modal.css";

interface ModalProps {
  open: boolean;
  onClose?: () => void;
  title?: string;
  children: ReactNode;
  size?: "small" | "medium" | "large";
}

const Modal: FC<ModalProps> = ({
  open,
  onClose,
  title,
  children,
  size = "small",
}) => {
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";
  }, [open]);

  if (!open) {
    return null;
  }

  const width =
    size === "small" ? "500px" : size === "medium" ? "800px" : "1200px";
  const maxHeight =
    size === "small" ? "80vh" : size === "medium" ? "84vh" : "88vh";

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1001,
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1rem",
      }}
      role="dialog"
      aria-modal="true"
      aria-labelledby={title ? "modal-title" : undefined}
    >
      <div
        className="modal-inner"
        style={{
          background: "linear-gradient(to bottom, #1e293b, #0f172a)",
          padding: "2rem",
          borderRadius: "0.5rem",
          maxWidth: width,
          width: "100%",
          color: "white",
          position: "relative",
          border: "1px solid rgba(148, 163, 184, 0.2)",
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
          maxHeight: maxHeight,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "1rem",
            flexShrink: 0,
          }}
        >
          {title && (
            <h3
              id="modal-title"
              style={{
                fontSize: "1.5rem",
                fontWeight: "bold",
                margin: 0,
                color: "white",
              }}
            >
              {title}
            </h3>
          )}
          {onClose && (
            <button
              onClick={onClose}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: "1.5rem",
                color: "white",
              }}
              aria-label="Close modal"
            >
              ×
            </button>
          )}
        </div>
        <div
          className="modal-body-scroll"
          style={{
            flex: 1,
            minHeight: 0,
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
